export default class MicrosoftAds {
  constructor(tagId: string) {
    const script = document.createElement('script')
    script.textContent = `
      (function(w,d,t,r,u)
      {
        var f,n,i;
        w[u]=w[u]||[],f=function()
        {
          var o={ti:"${tagId}", enableAutoSpaTracking: true};
          o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")
        },
        n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function()
        {
          var s=this.readyState;
          s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)
        },
        i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)
      })
      (window,document,"script","//bat.bing.com/bat.js","uetq");
    `
    document.head.appendChild(script)
  }

  public newLead() {
    this.sendEvent('form_submitted', {})
  }

  public isAvailable() {
    return true
  }

  private sendEvent(eventName: string, eventData: unknown) {
    ;(window as any).uetq.push('event', eventName, eventData)
  }
}
